/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Form, Select } from 'antd'
import _ from 'lodash'
import { observer } from 'mobx-react'
import { compose } from 'recompose'
import { 
	GENERIC_LOOKUP
} from '../../../../constants/lookup'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { form } = this.props
		const { getFieldDecorator } = form
        
		return (
			<React.Fragment>
				<Row gutter={16}>
					<Col md={6} sm={24}>
						<Form.Item label='Voters ID'>
							{ getFieldDecorator('voters_id', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Voters ID number' />
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='Precint Number'>
							{ getFieldDecorator('precint_no', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Precint number' />
							)}
						</Form.Item>
					</Col>
					<Col md={4} sm={24}>
						<Form.Item label='Registered Voter?'>
							{ getFieldDecorator('registered_voter', {
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select'>
									{
										GENERIC_LOOKUP.map((i, key) => (
											<Select.Option key={key} value={i.value}>{i.value}</Select.Option>
										))
									}
								</Select>
							)}
						</Form.Item>
					</Col>
				</Row>
			</React.Fragment>
		)
	}
}

const composed = compose(
	observer
)

export default composed(Index)
